

















import { Component, Prop, Vue } from 'vue-property-decorator';

type NumberOrString = number | string;

@Component
export default class ComponentsSvgiconSvgbase extends Vue {
  // Props
  @Prop({ type: String, default: 'box', })
  iconName: string;

  @Prop({ type: String, default: 'transparent', })
  iconColor: string;

  @Prop({ type: [Number, String], default: 16, })
  width: NumberOrString;

  @Prop({ type: [Number, String], default: 16, })
  height: NumberOrString;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/svgicon/Svgbase.vue